import { render, staticRenderFns } from "./Notice.vue?vue&type=template&id=6ab93bd0&scoped=true&"
import script from "./Notice.vue?vue&type=script&lang=js&"
export * from "./Notice.vue?vue&type=script&lang=js&"
import style0 from "./Notice.vue?vue&type=style&index=0&id=6ab93bd0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab93bd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6ab93bd0')) {
      api.createRecord('6ab93bd0', component.options)
    } else {
      api.reload('6ab93bd0', component.options)
    }
    module.hot.accept("./Notice.vue?vue&type=template&id=6ab93bd0&scoped=true&", function () {
      api.rerender('6ab93bd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/index/Portal/Notice.vue"
export default component.exports